module.exports = __webpack_public_path__ + "static/media/colicoli24.18812a73.webp";